function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M57 63h6M51.002 63h2.571M43.287 42.427h6.857",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.288 12.858H48.43M57.001 12.858h-3.429",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.143 59.143v-27m-46.286 0v19.286M9 59.143h54M21.536 37.929H34.07v13.5H18.643V40.82m21.214 18.322V40.82a2.893 2.893 0 012.893-2.892h7.714a2.893 2.893 0 012.893 2.892v18.322m-40.5-4.286v4.286M53.357 9H19.714c-1.821 0-2.143.857-3.725 3.671L9.52 24.068c-1.758 3.834 1.16 8.178 5.687 8.317h.242c3.784 0 6.852-1.32 6.852-4.581 0 3.254 3.069 4.58 6.854 4.58 3.784 0 6.846-1.103 6.846-4.58 0 3.254 3.068 4.58 6.852 4.58 3.785 0 6.854-1.103 6.854-4.58 0 3.477 3.068 4.58 6.853 4.58h.235c4.527-.14 7.445-4.484 5.688-8.316l-5.22-11.396C56.242 10.447 55.985 9 53.358 9z",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHubPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/hub-point.svg";
export { SvgHubPoint as ReactComponent };